import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation MFATOTPSetup {
    mfaTotpSetup {
      code
    }
  }
`

export const mfaTotpSetupKey = getQueryNames(mutation)[0]

export default mutation
